export enum ColumnTypes {
  USER = 'User',
  DATE = 'Date',
  REGISTRATION_DATE = 'Registration Date',
  PROJECT = 'Project',
  COMMUNITY = 'Community',
  MANAGE = 'Manage',
  SPECIALTIES = 'Specialty',
  DISEASES = 'Diseases',
  DESCRIPTION = 'Description',
  DEACTIVATIONS = 'Deactivations',
  LAST_VISIT = 'Last visit',
}

export enum CellType {
  MANAGE = 'manage',
  REMOVE = 'remove',
  MANAGE_RELATION = 'manageRelation',
}
